import {WeatherForecastDay} from '@/app/interfaces/weather';
import {createAsyncThunk} from '@/app/store/createAsyncThunk';
import {selectForecastData, selectForecastLanguage, selectForecastLocationId} from '@/app/store/forecast/selectors';

type UpdateMode =
	| {
			type: 'currentDay';
			date: string;
	  }
	| {
			type: 'all';
			selectedDate?: string;
	  };

/**
 * Fetch full data set to show the forecast page by a directly defined settlement
 */
export const reFetchForecastDataAction = createAsyncThunk<
	{
		mode: UpdateMode;
	},
	{
		mode: UpdateMode;
		forecast: WeatherForecastDay[];
	}
>('forecast/reFetchForecastDataAction', async (params, {context, getState, success}) => {
	const {mode} = params;
	const {backendAPI} = context;

	const state = getState();
	const language = selectForecastLanguage(state)!;
	const locationId = selectForecastLocationId(state)!;
	const currentForecast = selectForecastData(state)!.forecast;

	const {forecast} = await backendAPI.forecast.getForecast(
		language,
		locationId,
		mode.type === 'currentDay' ? 1 : currentForecast.length,
		mode.type === 'currentDay' ? mode.date : undefined,
		mode.type === 'all' ? mode.selectedDate : undefined,
	);

	// TODO refresh also an extra info with weather (re-links or main page locations, resorts, ...)

	return success({forecast, mode});
});
